import http from '@/utils/http';
import i18n from '@/main';

const URL_BASE = '/pssc';

export default {

    buscarLotes() {
        return http.get({
            url: URL_BASE + '/lotes-usuario',
            lockScreen: false
        });
    },

    buscarElegiveis(payload) {
        return http.post({
            url: URL_BASE + '/buscar-elegiveis-filtros',
            data: payload,
            lockScreen: false
        });
    },

    buscarPorFiltro(payload, lockScreen) {
        return http.post({
            url: URL_BASE + '/buscar-filtros',
            data: payload,
            lockScreen: lockScreen
        });
    },

    buscarTotalizadores(payload) {
        return http.post({
            url: URL_BASE + '/totalizadores',
            data: payload,
            lockScreen: false
        });
    },

    inserirLote(payload) {
        return http.post({
            url: URL_BASE + `/inserir-lote`,
            data: payload,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.pssc.telaIncluirTerritorios.criandoNovoLote')
        });
    },

    consolidarLote(payload) {
        return http.post({
            url: URL_BASE + `/consolidar-lote`,
            data: payload,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.pssc.telaIncluirTerritorios.consolidandoLote')
        });
    },

    buscarLocalidadeTerritoriosElegíveis(payload) {
        return http.post({
            url: URL_BASE + '/buscar-localidade-pssc',
            data: payload,
            lockScreen: false
        });
    },

    pesquisaInteligentePssc(busca) {
        return http.post({
            url: URL_BASE + `/pesquisa-inteligente`,
            data: busca,
            lockScreen: false
        });
    },

    buscarDadosContatoTerritorio(idTerritorio) {
        return http.get({
            url: URL_BASE + `/dados-contato-territorio/${idTerritorio}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.pssc.telaLista.modalEditarDadosContato.buscarDadosContatoLockMessage')
        });
    },

    atualizarContatos(contatos) {
        return http.put({
            url: URL_BASE + '/atualizar-dados-contato',
            data: contatos,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.pssc.telaLista.modalEditarDadosContato.buscarDadosContatoLockMessage')
        });
    },

    buscarVisaoGeral(payload) {
        return http.post({
            url: URL_BASE + '/buscar-visao-geral',
            data: payload,
            lockScreen: false
        });
    },
    buscarTotalizadorTrilhas(payload) {
        return http.post({
            url: URL_BASE + '/dashboard/buscar-totalizador-trilha',
            data: payload,
            lockScreen: false
        });
    },

    buscarTotalizadorTerritorio(payload) {
        return http.post({
            url: URL_BASE + '/dashboard/buscar-totalizador-territorio',
            data: payload,
            lockScreen: false
        });
    },

    buscarInformacoesGeraisTerritorio(id) {
        return http.post({
            url: URL_BASE + `/territorio/${id}/dados-gerais/`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.pssc.telaVisaoGeralTerritorio.buscandoInformacoesGeraisTerritorio')
        });
    },

    buscarDadosDiagnosticoCar(id) {
        return http.get({
            url: URL_BASE + `/territorio/${id}/dados-diagnostico/`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.pssc.telaVisaoGeralTerritorio.buscandoDadosDiagnosticoCar')
        });
    },

    buscarDadosDiagnosticoRepresentante(id) {
        return http.get({
            url: URL_BASE + `/territorio/${id}/dados-diagnostico-representante/`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.pssc.telaVisaoGeralTerritorio.buscandoDadosDiagnosticoRepresentante')
        });
    },

    buscarDadosConformidadeCfb(id) {
        return http.get({
            url: URL_BASE + `/territorio/${id}/dados-conformidade-cfb/inconsistencias`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.pssc.telaVisaoGeralTerritorio.buscandoDadosConformidadeCfb')
        });
    },

    buscarDadosAreaTotal(payload) {
        return http.post({
            url: URL_BASE + '/dashboard/buscar-dados-area-total',
            data: payload,
            lockScreen: false
        });
    },

    buscarTotalizadorCoberturaSoloDashboard(payload) {
        return http.post({
            url: URL_BASE + '/dashboard/buscar-totalizador-cobertura-solo-overview',
            data: payload,
            lockScreen: false
        });
    },

    dispararTrilha(payload) {
        return http.post({
            url: URL_BASE + `/enviar-trilha`,
            data: payload,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.pssc.telaLista.tabela.enviandoTrilha')
        });
    },

    reprocessarTerritorios() {
        return http.post({
            url: URL_BASE + `/territorio/reprocessar`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.pssc.telaLista.tabela.enviandoParaReprocessamento')
        });
    }
};
